<template>
    <div class="main-content-container container-fluid px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 flex-header text-center text-sm-left mb-0">
                <h3 class="page-title">Sprawy w egzekucji</h3>
            </div>
        </div>

        <!-- Default Light Table -->
        <template v-if="loadError">
            <d-alert
                show
                theme="warning">
                Wczytywanie danych nie powiodło się.
                <a
                    href="javascript:window.location.reload();"
                    class="alert-link">
                    Odśwież stronę
                </a>
                aby spróbować ponownie.
            </d-alert>
        </template>
        <template v-else>
            <transition name="fade">
                <d-card class="card-small">
                    <div
                        v-if="!loaded"
                        class="overlay-loading">
                        <h2 class="preloader isLoading">Trwa ładowanie</h2>
                    </div>
                    <d-card-header class="border-bottom flex-header">
                        <div class="search-wrapper">
                            <d-input-group>
                                <d-input
                                    class="form-control"
                                    placeholder="Szukaj"
                                    v-model="filters.search" />
                                <d-select
                                    v-model="filters.bailiff_id"
                                    placeholder="Wpisz dane komornika...">
                                    <option :value="null">Wybierz komornika</option>
                                    <option
                                        :value="ballif.id"
                                        v-for="ballif in allBailiffs"
                                        :key="ballif.id">
                                        {{ ballif.name }}
                                    </option>
                                </d-select>
                                <button
                                    class="button btn autocomplete-clear btn-primary"
                                    @click.prevent="filterList">
                                    Szukaj
                                </button>
                                <button
                                    class="button btn autocomplete-clear btn-secondary"
                                    @click.prevent="clearFilters">
                                    Wyczyść
                                </button>
                            </d-input-group>
                        </div>
                    </d-card-header>
                    <d-card-body class="p-0 pb-2 text-center">
                        <table class="table mb-0 responsive-table">
                            <thead class="bg-light">
                                <tr>
                                    <th scope="col" class="border-0 id-cell">Numer umowy</th>
                                    <th scope="col" class="border-0 id-cell">Sygnatura sprawy</th>
                                    <th scope="col" class="border-0 id-cell">Klient</th>
                                    <th scope="col" class="border-0 id-cell">Komornik</th>
                                    <th scope="col" class="border-0 id-cell">Saldo zadłużenia</th>
                                    <th scope="col" class="border-0 id-cell">Akcje</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(execution) in executions" :key="execution.id">
                                    <td>
                                        <dt>Numer umowy</dt>
                                        <dd>{{ execution.contract_number }}</dd>
                                    </td>
                                    <td>
                                        <dt>Sygnatura sprawy</dt>
                                        <dd>{{ execution.number }}</dd>
                                    </td>
                                    <td>
                                        <dt>Klient</dt>
                                        <dd>{{ execution.client_name }} {{ execution.last_name }}</dd>
                                    </td>
                                    <td>
                                        <dt>Komornik</dt>
                                        <dd>{{ execution.bailiff_name }}</dd>
                                    </td>
                                    <td>
                                        <dt>Saldo zadłużenia</dt>
                                        <dd>{{ toNumber(execution.amount_of_debt) }} zł</dd>
                                    </td>
                                    <td>
                                        <dt>Akcja</dt>
                                        <dd class="wsnw">
                                            <d-button
                                                @click="$router.push({name: 'contract-edit', params: {client_id: execution.client_id, schedule_id: execution.schedule_id, case_id: execution.id, from: 'executions-list'}})"
                                                class="mr-2 mt-1 mb-1 ml-2">
                                                <i class="material-icons">search</i> Pokaż
                                            </d-button>
                                        </dd>
                                    </td>
                                </tr>
                                <tr v-if="!executions.length">
                                    <td colspan="6" class="text-center text-info">
                                        Brak spraw do wyświetlenia&hellip;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </d-card-body>
                    <d-card-footer>
                        <ss-pagination
                            :meta-data="paginationMetaData"
                            :initial-page="currentPage" />
                    </d-card-footer>
                </d-card>
            </transition>
        </template>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import SsPagination from '@/components/common/SsPaginationNew';
import HasFilters from '@/mixins/HasFilters.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import ListUtils from '@/utils/ListUtils.js';

export default {
    name: 'ExecutionsList',
    mixins: [HasFilters, HasPagination],
    components: {
        SsPagination,
    },
    data () {
        return {
            executions: [],
            loaded: false,
            loadError: false,
            filters: {
                bailiff_id: null,
                search: ''
            }
        }
    },
    computed: {
        ...mapGetters([
            'allBailiffs'
        ])
    },
    mounted () {
        this.getAllBailiffs();
        this.loadExecutions();
    },
    methods: {
        ...mapActions ([
            'getAllBailiffs'
        ]),
        loadExecutions () {
            ListUtils.loadItemsData(this, {
                method: 'post',
                endpoint: '/api/contracts-case/get-all-cases',
                listField: 'executions',
                pagination: true,
                params: {
                    page: this.currentPage,
                    where: this.filters,
                    short: true
                }
            });
        },
        debouncedLoadFilteredData: _.debounce(function () {
            Vue.set(this, 'loaded', false);
            Vue.set(this, 'loadError', false);
            this.loadExecutions();
        }, 500),
        filterList () {
            Vue.set(this, 'loaded', false);
            Vue.set(this, 'loadError', false);
            this.$bus.$emit('pagination-reset');
            this.$bus.$emit('view-filters-save');
        },
        clearFilters () {
            Vue.set(this, 'loaded', false);
            Vue.set(this, 'loadError', false);
            this.filters = {
                bailiff_id: null,
                search: ''
            };
            this.$bus.$emit('view-filters-reset');
            this.$bus.$emit('pagination-reset');
        },
        toNumber (number) {
            return Vue.toNumber(number);
        }
    }
}
</script>
